import { InputLabel, styled } from "@mui/material";

const StyledInputLabel = styled(InputLabel)`
  margin-right: auto;
  font-size: ${(props) => props.theme.wsc.typography.body3.fontSize};
  font-weight: ${(props) => props.theme.wsc.typography.body3.fontWeight};
  color: ${(props) => props.theme.wsc.palette.neutral[200]};
  margin-top: 0;
  margin-bottom: ${(props) => props.theme.wsc.spacing[1]};

  & .MuiFormLabel-asterisk {
    color: ${(props) => props.theme.wsc.palette.warning[100]};
  }
`;

export default StyledInputLabel;
